import { Button } from '@/components/ui/Button';
import { XStack } from '@/components/ui/layout/layout';

export const CredentialNotificationRetry = ({
  pending,
  isError,
  onRetry,
}: {
  pending: boolean;
  isError: boolean;
  onRetry: () => void;
}) => (
  <XStack className="absolute inset-x-3 bottom-3 z-10 items-center justify-between gap-3 rounded-lg border border-border bg-surface p-3 text-foreground shadow-lg">
    <p role="alert" className="text-sm">
      {isError
        ? 'Couldn’t notify the agent. Please retry.'
        : 'The agent hasn’t received your response yet.'}
    </p>
    <Button size="sm" disabled={pending} onClick={onRetry}>
      Retry
    </Button>
  </XStack>
);
